module.exports = __webpack_public_path__ + "static/media/isle-of-death.d8de3e4c.jpg";